"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Delete12Icon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'delete-12', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "12px",
    width: "12px",
    version: "1.1",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("title", null, "\u753B\u677F"), /*#__PURE__*/_react.default.createElement("g", {
    id: "\u753B\u677F",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "\u5F62\u72B6",
    d: "M4.81084,0.37505 C4.61179,0.37505 4.4209,0.4541776 4.28023,0.595004 L3.9698,0.905768 C3.82907,1.04664 3.63811,1.125772 3.43899,1.125722 L1.50009,1.125237 C1.08586,1.125133 0.75,1.46091 0.75,1.87514 C0.75,2.28931 1.08574,2.62505 1.49991,2.62505 L10.5001,2.62505 C10.9143,2.62505 11.25,2.28931 11.25,1.87514 C11.25,1.46091 10.9141,1.125134 10.4999,1.125238 L8.56101,1.125726 C8.36189,1.125777 8.17092,1.046645 8.0302,0.905772 L7.71977,0.595008 C7.5791,0.4541823 7.38821,0.37505 7.18916,0.37505 L4.81084,0.37505 Z M9.71223,3.37505 C9.31418,3.37505 8.98283,3.68601 8.96076,4.08345 L8.62511,10.12574 L3.37489,10.12574 L3.03924,4.08345 C3.01717,3.68601 2.68582,3.37505 2.28777,3.37505 C1.86019,3.37505 1.51622,3.73197 1.53564,4.15911 L1.80991,10.1931 C1.84633,10.99425 2.50642,11.62495 3.30837,11.62495 L8.69163,11.62495 C9.49358,11.62495 10.1537,10.99425 10.1901,10.1931 L10.4644,4.15911 C10.4838,3.73197 10.1398,3.37505 9.71223,3.37505 Z M5.25,8.6251 C5.25,9.03928 5.58576,9.37504 5.99995,9.37504 C6.41413,9.37504 6.74989,9.03928 6.74989,8.6251 L6.74989,4.875 C6.74989,4.46081 6.41413,4.12505 5.99995,4.12505 C5.58576,4.12505 5.25,4.46081 5.25,4.875 L5.25,8.6251 Z",
    fill: "currentColor"
  })));
});
var _default = Delete12Icon;
exports.default = _default;